<template>
  <div class="dialog_warp">
    <div class="dialog_form">
      <div class="title">基础信息：</div>
      <el-row class="g-row">
        <el-col :span="12">合同编号：{{info.contractNumber}}</el-col>
        <el-col :span="12">合同类型：{{contractType|contractType}}</el-col>
      </el-row>
      <div class="title" v-if="contractType<3">场地信息：</div>
      <div class="title" v-else>房源及入住人信息：</div>
      <div class="g-basic-data">
        {{info.build}}<span>{{info.floor}}</span>{{info.room}}<span>{{info.area}}(m²)</span>
      </div>
      <div class="g-basic-data" v-if="contractType>2" style="border-top:1px solid #ccc;">
        {{info.zuhulianxiren}}<span>{{info.zuhuPhone}}</span><span></span>
      </div>
      <div class="title" v-if="contractType == 1 || contractType == 3">租赁条款摘要：</div>
      <div class="title" v-if="contractType == 2 || contractType == 4">物业合同信息：</div>
      <div class="g-contract" >
        <p v-if="info.hetongzuqi">• {{info.hetongzuqi}}</p>
        <p v-if="info.hetongmianji">• {{info.hetongmianji}}</p>
        <p v-if="info.heyuezujin" v-for="(item,index) in info.heyuezujin" :key="'heyue'+index">• {{item}}</p>
        <p v-if="info.mianzutiaokuan" v-for="(item,index) in info.mianzutiaokuan" :key="'mianzu'+index">• {{item}}</p>
      </div>
      <div class="text-center" style="margin-top:10px">
        <el-button size="small" class="f-search-btn g-success" type="success" @click="electronicContractDialog = true;">查看电子合同</el-button>
        <el-button size="small" class="f-search-btn g-success" type="success" @click="contractBillDialog = true;">查看账单明细</el-button>
      </div>
    </div>
    <!--电子合同查看-->
    <el-dialog title="电子合同查看" class="electronic-contract" append-to-body :visible.sync="electronicContractDialog" width="50%" center
                top="3%">
      <v-electronic-contract v-if="electronicContractDialog" :contractId="contractId" :contractType="contractType>2?contractType+1:contractType"
                              @closeDialog="electronicContractDialog=false"></v-electronic-contract>
    </el-dialog>

    <!--电子合同查看-->
    <el-dialog title="合同账单明细" class="contract-bill" append-to-body :visible.sync="contractBillDialog" width="50%" center
                top="3%">
      <v-bill-details v-if="contractBillDialog" @closeDialog="contractBillDialog=false" :contractId="contractId" :contractType="contractType == 1||contractType == 3 ? 1 : 2"></v-bill-details>
    </el-dialog>

  </div>
</template>

<script>
  import * as global from '../config/mUtils'
  import * as getData from "../service/getData";
  export default {
    data() {
      return {
        info: {
          heyuezujin:[],
          mianzutiaokuan:[],
        },
        fileList: [],
        submitLoading: false,
        conts: '',
        tableList:[],
        parkListLoading:false,
        electronicContractDialog:false,
        contractBillDialog:false,
        fileOutPath:'',
        filters:{
          contractId:'',
          type:'',
        }
      }
    },
    created() {
    },
    mounted() {
      this.filters.contractId = this.contractId;
      this.filters.type = this.contractType;
      this.init();
    },
    computed: {},
    props:['contractId','contractType'],
    methods: {
      close(type) {
        if (type === 1) {
          this.$emit('init')
        } else {
          this.$emit('closeDialog')
        }
      },
      init() {
        getData.contractDetail(this.filters).then(res => {
          this.parkListLoading = false;
          if (res.data.code == "success") {
            this.info = res.data.data.data.contractVO;
          }
        }).catch(_ => {
          console.log(_);
          this.parkListLoading = false;
        });
      },
    },
    components: {},
    watch: {},
  }
</script>
<style lang="scss">
.g-contp{
  img{
    width: fit-content;
    max-width: 100%;
  }
}
.contract-bill{
  .el-dialog__body{
    padding:0;
  }
}

</style>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .dialog_warp{
    padding: 0;
    margin:0;
    background: #fff;
  }
  .dialog_form {
    margin:0;
    padding: 10px;
    background: #f2f3f5;
  }
  .title{
    font-size:14px;
    margin:5px 0;
  }
  .g-basic-data{
    padding: 20px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .g-contract{
    padding: 20px;
    background: #fff;
    p{
      margin-top:5px;
    }
  }
  .g-row{
    padding: 20px;
    background: #fff;
  }



</style>



// WEBPACK FOOTER //
// src/components/contract-details.vue